import over from 'lodash/over';
import moment from 'moment-timezone';
import { getSeriesValue } from '../../panel/components/instruments/chartInstrument/utils/dataUtils';
import { isChartInstrument, isHeatmapInstrument, isMetricInstrument, isPresenceInstrument, isTableInstrument, } from '../../panel/utils/groupInstruments';
const dateFormat = 'YYYY-MM-DD HH:mm:ss';
export const transformInstrumentsToCSV = (...args) => over([
    transformMetricInstruments,
    transformChartInstrument,
    transformTableInstrument,
    transformPresenceInstrument,
])(...args).filter((record) => record === null || record === void 0 ? void 0 : record.data.length);
const transformMetricInstruments = (instruments) => {
    const metricInstruments = instruments.filter(isMetricInstrument);
    return {
        instrumentType: 'metric',
        data: metricInstruments.reduce((data, instrument) => {
            if (!data[0]) {
                data.push({
                    [instrument.title]: instrument.data,
                });
            }
            else {
                data[0][instrument.title] = instrument.data;
            }
            return data;
        }, []),
    };
};
const transformChartInstrument = (instruments, { timezone }) => {
    const chartInstrument = instruments.find(isChartInstrument) ||
        instruments.find(isHeatmapInstrument);
    if (!chartInstrument ||
        !chartInstrument.data.categories.length ||
        !chartInstrument.data.series.length) {
        return {
            instrumentType: 'chart',
            data: [],
        };
    }
    const { data: { categories, series }, } = chartInstrument;
    const hasDateCategories = moment(categories[0].label, moment.ISO_8601).isValid();
    return {
        instrumentType: 'chart',
        data: categories.map((category, categoryIndex) => (Object.assign({ [hasDateCategories ? 'Date' : '-']: hasDateCategories
                ? moment.tz(category.label, timezone).format(dateFormat)
                : category.label }, series.reduce((acc, item) => (Object.assign(Object.assign({}, acc), { [item.label]: getSeriesValue(item.data[categoryIndex]).value })), {})))),
    };
};
const transformPresenceInstrument = (instruments) => {
    var _a, _b, _c, _d;
    const presenceInstrument = instruments.find(isPresenceInstrument);
    if (!presenceInstrument) {
        return {
            instrumentType: 'presence',
            data: [],
        };
    }
    const { data: { availability, media_type }, } = presenceInstrument;
    return {
        instrumentType: 'presence',
        data: [
            ...media_type.map((media) => ({
                _: media.label,
                Working: media.value,
                Away: Math.max(100 - media.value, 0),
            })),
            {
                _: 'Total',
                Working: (_b = (_a = availability[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0,
                Away: (_d = (_c = availability[1]) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 0,
            },
        ],
    };
};
const transformTableInstrument = (instruments, { timezone }) => {
    const tableInstrument = instruments.find(isTableInstrument);
    if (!tableInstrument) {
        return {
            instrumentType: 'table',
            data: [],
        };
    }
    const { data: { columns, rows, options }, } = tableInstrument;
    return {
        instrumentType: 'table',
        data: rows.map((row) => (Object.assign({}, columns.reduce((acc, column, columnIndex) => (Object.assign(Object.assign({}, acc), { [column.label]: transformTableInstrumentDataValue(row.cells[columnIndex].value, column.format, timezone) })), {})))),
        meta: {
            warning: (options === null || options === void 0 ? void 0 : options.next_page)
                ? `Only the first ${options.limit} table results will be exported. Go back and click "Load all results" to export the full dataset.`
                : undefined,
        },
    };
};
const transformTableInstrumentDataValue = (value, format, timezone) => {
    if (value === null)
        return null;
    switch (format) {
        case 'date':
            return moment.tz(value, timezone).format(dateFormat);
        case 'boolean':
            return value ? 'Y' : 'N';
        case 'tags':
            return value.map(({ name }) => name).join('\n');
        default:
            return value;
    }
};
